import React, { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./ModalEmbarque.css";
import { useCidade } from "../../contexts/FilialContext.tsx";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../CloseIcon/CloseIcon";
import { useProfile } from "../../contexts/ProfileContext.tsx";

export interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  onClick: (value: string) => void;
}

function ModalEmbarque(props: SimpleDialogProps) {

  const { dadosFilialRedux } = useCidade();

  const { handleSetContextoEmbarque } = useProfile();
  const navigate = useNavigate();

  const onClick2 = useCallback((item) => {
    handleSetContextoEmbarque(item.contexto);
    navigate("/viagens/" + item.contexto);
  }, [handleSetContextoEmbarque, navigate]);

  const { onClose, open, } = props;

  const handleClose = () => {
    onClose();
  };
  return (
    <div>
      <Dialog open={open}>
        <div className="modal-embarque">
          <div className="div-modal-embarque">
            <div className="titulo-modal-embarque">
              <DialogTitle id="alert-dialog-title">
                <h3 className="title-modal-embarque">Filiais</h3>
              </DialogTitle>
              <CloseIcon
                onClick={(e) => {
                  handleClose();
                }}
              />
            </div>
            <DialogContent>
              <p>
                Ops, parece que você não tem permissão ou o sistema não se
                lembra onde você estava, por favor, escolha uma filial.
              </p>
              <DialogContentText>
                {dadosFilialRedux.map((item) => {
                  if (item.nomeFilial !== "Modelo Viagens") {
                    return (
                      <p
                        key={item.nomeFilial}
                        className="options"
                        onClick={() => {
                          onClick2(item);
                        }}
                      >
                        {item.nomeFilial}
                      </p>
                    );
                  }
                })}
              </DialogContentText>
            </DialogContent>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ModalEmbarque;
